import { Injectable, inject } from '@angular/core';
import { RequestBuilderService } from '../../../shared/services/request-builder.service';
import { map, Observable, of, shareReplay } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DriverDetailsCacheService {
  private readonly requestBuilder = inject(RequestBuilderService);

  private readonly availabilityCache = new Map<string, any>();
  private readonly imgCache = new Map<string, any>();

  // Cache and fetch availabilityStatus
  getAvailabilityStatus(contractorId: number): Observable<any> {
    const cacheKey = `availability-${contractorId}`;

    // Return cached data if available
    if (this.availabilityCache.has(cacheKey)) {
      return of(this.availabilityCache.get(cacheKey));
    }

    // Fetch data from the API and cache it
    return this.requestBuilder.get(`drivers/partner-availability/${contractorId}`).pipe(
      map((res: any) => {
        this.availabilityCache.set(cacheKey, res.data);
        return res.data;
      }),
      shareReplay(1), // Share the response with multiple subscribers
    );
  }

  resetAvailabilityCache() {
    this.availabilityCache.clear();
  }

  getImageUrl(driverImg: string, driverId: number) {
    const cacheKey = `img-${driverId}`;

    if (this.imgCache.has(cacheKey)) {
      return of(this.imgCache.get(cacheKey));
    }

    const img = driverImg;
    if (!img) {
      return of('');
    }

    const parts = img.split('/');
    const b = parts[0];
    if (parts.length > 1) {
      parts.shift();
      const lastSegment = parts.at(-1); // remove timetsamp  in last segment
      if (!Number.isNaN(Number(lastSegment))) {
        parts.pop();
      }
      const s3Key = parts.join('/');
      if (s3Key.startsWith('partners') && s3Key.includes('profile_photo')) {
        const encodedKey = encodeURIComponent(s3Key);
        return this.requestBuilder.get(`ride-drivers/partner/avatar/${b}/${encodedKey}`).pipe(
          map((res: any) => {
            this.imgCache.set(cacheKey, `data:image/jpeg;base64, ${res.message}`);
            return `data:image/jpeg;base64, ${res.message}`;
          }),
          shareReplay(1), // Share the response with multiple subscribers
        );
      }
    }

    return of('');
  }
}
